import request from '../servises/request'
import axios from 'axios'

export function getTinderAccounts(pr) {
  let params
  if (pr) {
    params = `?${pr}`
  }
  return request({
    url: pr ? `/tinder-account${params}` : '/tinder-account',
    method: 'GET'
  })
}

export function getPaidProxies() {
  return request({
    url: '/proxy/paid',
    method: 'GET'
  })
}
export function getPhoneProviders() {
  return request({
    url: '/phone-providers',
    method: 'GET'
  })
}

export function getTinderAccountGroups() {
  return request({
    url: '/tinder-account/groups',
    method: 'GET'
  })
}

export function getCountries() {
  return request({
    url: '/tinder-account/country',
    method: 'GET'
  })
}

export function showTinderAccount(account_id) {
  return request({
    url: `/tinder-account/${account_id}`,
    method: 'GET'
  })
}

export function createTinderAccount(data) {
 return request({
   url: '/tinder-account/',
   method: 'POST',
   data: data
 })
}

export function updateTinderAccount(data) {
  return request({
    url: `/tinder-account/${data.id}`,
    method: 'PUT',
    data: data
  })
}

export function deleteTinderAccount(tinder_account_id) {
  return request({
    url: `/tinder-account/${tinder_account_id}`,
    method: 'DELETE'
  })
}

export function authorizeTinderAccount(account_id) {
  return axios.get(
      `${process.env.VUE_APP_MICROSERVICE}/api/tinder/account/${account_id}/authorize`,
      {
          headers: {
              Accept: 'application/json'
          },
          timeout: 100000
      }
  )
}
